// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3hm8O","footer":"ModalFilter_footer__3177H"};